// TODO これはレビュー環境用のauth0の情報
export const config = {
  clientID: "axBWisOV3rdETV10SwNfgB8oNphMg1Bc",
  domain: "dev-sharefull.auth0.com"
};
